import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import moment from 'moment'
import merge from 'deepmerge'
import { listIds, setStatus, getParams, compactAndFilter } from '@/utils'

const module = 'baskets'
let doc = {
  list: {
    name: 'Paniers',
    headers: [
      { label: 'Nom', value: 'name' },
      { label: 'Client', value: 'client.name' },
      { label: 'Début', value: 'dateStart', orig: 'date_start', card: false },
      { label: 'Fin', value: 'dateEnd', orig: 'date_end', card: false },
      { label: 'Statut', value: 'status.name' },
      { label: 'Dates', value: 'dates', sortable: false, inTable: false, inDetail: false },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['baskets.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['baskets.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
    search: [
      { label: 'Début', type: 'date', name: 'from' },
      { label: 'Fin', type: 'date', name: 'to' },
      { label: 'Client', type: 'multilist', name: 'client_id', from: 'name', source: 'clients' },
      { label: 'Status', type: 'multilist', from: 'name', name: 'status_id', source: 'statuses' },
    ],
  },

  form: {
    name: 'Panier',
    fields: [
      { label: 'Nom', type: 'text', name: 'name' },
      { label: 'Client', type: 'list', from: 'name', name: 'client_id', source: 'clients' },
      { label: 'Début', type: 'date', name: 'date_start' },
      { label: 'Fin', type: 'date', name: 'date_end' },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['baskets.update'], dispatch: `${module}/update` },
      { label: 'Dupliquer', icon: 'library_add', scope: ['baskets.create'], adhoc: 'duplicate' },
      { label: 'Duplication sélective', icon: 'flip_to_back', scope: ['baskets.create'], adhoc: 'safeDuplicate' },
      { label: 'Confirmer', icon: 'check', filter: {status_id: 3}, scope: ['baskets.update'], dispatch: `${module}/confirmBasket` },
    ],
    adhoc: {
      duplicate: {
        name: 'Dupliquer le panier',
        fields: [
          { label: 'Début', type: 'date', name: 'date_start' },
          { label: 'Fin', type: 'date', name: 'date_end' },
        ],
        dispatch: `${module}/duplicateBasket`,
      },
      safeDuplicate: {
        name: 'Duplication sélective',
        description: 'Les faces indisponibles seront écartées de la sélection',
        fields: [
          { label: 'Début', type: 'date', name: 'date_start' },
          { label: 'Fin', type: 'date', name: 'date_end' },
        ],
        dispatch: `${module}/safeDuplicateBasket`,
      },
    },
    relations: [
      {
        name: 'Réservations',
        source: 'bookings',
        headers: [
          { label: 'Type', value: 'face.board.board_type.name' },
          { label: 'Code', value: 'face.full_code' },
          { label: 'Adresse', value: 'face.board.adress' },
          { label: 'District', value: 'face.board.district.name' },
          { label: 'Ville', value: 'face.board.district.city.name' },
          { label: 'Région', value: 'face.board.district.city.region.name' },
        ],
        dispatch: 'getBookings',
        selectActions: [
          { label: 'Supprimer', icon: 'delete', scope: ['bookings.delete'], dispatch: `${module}/cancelBooking` },
          {
            label: 'Exporter en PDF',
            icon: 'fas fa-file-pdf',
            isFlat: true,
            dispatch: `bookings/export`,
            context: {format: 'pdf'},
            menu: true,
          },
          {
            label: 'Exporter en Excel',
            icon: 'fas fa-file-excel',
            isFlat: true,
            dispatch: `bookings/export`,
            context: {format: 'xls'},
            menu: true,
          },
          {
            label: 'Rapport',
            icon: 'assignment',
            isFlat: true,
            dispatch: `bookings/selectionReport`,
            menu: false,
          },
        ],
      },
      {
        name: 'Disponibles',
        source: 'faces',
        headers: [
          { label: 'Type', value: 'board.board_type.name' },
          { label: 'Code', value: 'full_code' },
          { label: 'Adresse', value: 'board.adress', truncate: true },
          { label: 'District', value: 'board.district.name' },
          { label: 'Ville', value: 'board.district.city.name' },
          { label: 'Région', value: 'board.district.city.region.name' },
        ],
        dispatch: 'getAvailable',
        selectActions: [
          { label: 'Réserver', icon: 'pan_tool', scope: ['bookings.create'], dispatch: `${module}/bookFaces` },
          {
            label: 'Exporter en PDF',
            icon: 'fas fa-file-pdf',
            isFlat: true,
            dispatch: `faces/export`,
            context: {format: 'pdf'},
            menu: true,
          },
          {
            label: 'Exporter en Excel',
            icon: 'fas fa-file-excel',
            isFlat: true,
            dispatch: `faces/export`,
            context: {format: 'xls'},
            menu: true,
          },
        ],
      },
    ],
  },

  params: {
    fetchAll: {include: 'client,status'},
    fetchOne: {include: 'client,status'},
  },
  postprocess: item => {
    let imgPath = item.client ? item.client.img_path : undefined
    let dateStart = moment(item.date_start).format('DD/MM/YYYY')
    let dateEnd = moment(item.date_end).format('DD/MM/YYYY')
    return {
      ...item,
      img_path: imgPath,
      dateStart,
      dateEnd,
      dates: `${dateStart} - ${dateEnd}`,
    }
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    getBookings: ({ commit }, payload) => {
      commit('SET_LOADING', true)
      const { context, data } = payload
      commit('bookings/LIST_REQUEST', payload, {root: true})
      let baseParams = getParams(context)
      let compacted = compactAndFilter(data)
      let params = {
        ...baseParams,
        ...compacted,
        basket_id: context.id,
        include: 'face.board.district.city.region,face.board.board_type',
      }
      apiClient.fetchCustom('bookings', `bookings/list`, params)
        .then(data => {
          commit('bookings/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          console.log(error)
          commit('bookings/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    getAvailable: ({ commit }, payload) => {
      commit('SET_LOADING', true)
      const { context, data } = payload
      commit('faces/LIST_REQUEST', payload, {root: true})
      let baseParams = getParams(context)
      let compacted = compactAndFilter(data)
      let params = {
        ...baseParams,
        ...compacted,
        include: 'board.district.city.region,board.board_type',
      }
      apiClient.fetchCustom('faces', `faces/available/basket/${context.id}`, params)
        .then(data => {
          // let recomputed = computeFaceCount(data)
          commit('faces/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('faces/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    bookFaces: ({ commit, dispatch }, payload) => {
      commit('SET_LOADING', true)
      const {context, data} = payload
      let nData = {ids: listIds(data)}
      commit('UPDATE_REQUEST', nData)
      apiClient.dropCache('faces')
      apiClient.postCustom(module, `baskets/${context.id}/bookings`, nData, getParams(context))
        .then(response => {
          commit('UPDATE_SUCCESS', response)
          dispatch('fetchOne', {accessors: {}, context, data: response.id})
          dispatch('getBookings', {accessors: {}, context, data: context.id})
          dispatch('getAvailable', {accessors: {}, context, data: context.id})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('UPDATE_ERROR', error)
          console.log(error)
          commit('SET_LOADING', false)
        })
    },
    duplicateBasket: ({ commit, dispatch }, payload) => {
      commit('SET_LOADING', true)
      commit('UPDATE_REQUEST', payload)
      const {context, data} = payload
      apiClient.postCustom(module, `baskets/${context.id}/duplicate`, data, getParams(context))
        .then(response => {
          dispatch('fetchOne', {accessors: {}, context, data: response.id})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('UPDATE_ERROR', error)
          commit('SET_LOADING', false)
        })
    },
    safeDuplicateBasket: ({ commit, dispatch }, payload) => {
      commit('SET_LOADING', true)
      commit('UPDATE_REQUEST', payload)
      const {context, data} = payload
      apiClient.postCustom(module, `baskets/${context.id}/safeduplicate`, data, getParams(context))
        .then(response => {
          dispatch('fetchOne', {accessors: {}, context, data: response.id})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('UPDATE_ERROR', error)
          commit('SET_LOADING', false)
        })
    },
    cancelBooking: ({ commit, dispatch }, payload) => {
      commit('SET_LOADING', true)
      const {context, data} = payload
      let nData = {ids: listIds(data)}
      console.log(nData)
      apiClient.dropCache('bookings')
      commit('UPDATE_REQUEST', nData)
      apiClient.postCustom(module, `baskets/${context.id}/cancel`, nData, getParams(context))
        .then(response => {
          commit('UPDATE_SUCCESS', response)
          dispatch('fetchOne', {accessors: {}, context, data: response.id})
          dispatch('getBookings', {accessors: {}, context, data: context.id})
          dispatch('getAvailable', {accessors: {}, context, data: context.id})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('UPDATE_ERROR', error)
          console.log(error)
          commit('SET_LOADING', false)
        })
    },
    confirmBasket: ({ commit, dispatch }, payload) => setStatus(apiClient, module, commit, dispatch, payload, 'confirmed'),
    deleteBasket: ({ commit, dispatch }, payload) => setStatus(apiClient, module, commit, dispatch, payload, 'deleted'),
  },
}
export default merge(base, custom)
